const PdfViewer = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src="/pdfs/NEMTProjectPlanSummary.pdf"
        width="100%"
        height="100%"
        title="NEMT PDF"
      />
    </div>
  );
};

export default PdfViewer;
